import {
  User,
  ChevronDown,
  Maximize2,
  Minimize2
} from 'lucide-react';
import { useState } from 'react';

const Header = ({ onSidebarToggle, sidebarOpen = false, isCollapsed = false, pageTitle = "Project settings" }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  const theme = {
    bg: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
    glassBg: 'rgba(255, 255, 255, 0.9)',
    text: '#1e293b',
    textSecondary: '#64748b',
    border: 'rgba(203, 213, 225, 0.3)',
    hoverBg: 'rgba(148, 163, 184, 0.1)',
    dropdownBg: 'rgba(255, 255, 255, 0.95)'
  };


  // Calculate dynamic margin based on sidebar state
  const getSidebarWidth = () => {
    if (!sidebarOpen) return 0;
    return isCollapsed ? 80 : 280;
  };

  const getEmail = localStorage.getItem("Email") || "";
  const displayName = getEmail.split("@")[0] || "User";

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(err => {
        console.log(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen().catch(err => {
        console.log(`Error attempting to exit fullscreen: ${err.message}`);
      });
    }
  };

  return (
    <header
      className="position-fixed top-0 w-100 shadow-sm"
      style={{
        height: '70px',
        background: theme.bg,
        backdropFilter: 'blur(20px)',
        borderBottom: `1px solid ${theme.border}`,
        zIndex: 1060, // Higher than sidebar's 1050
        left: 0,
        right: 0
      }}
    >
      <div
        className="h-100 px-4"
        style={{
          marginLeft: getSidebarWidth(),
          transition: 'margin-left 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      >
        <div className="row h-100 align-items-center navbar">
          {/* Left Section */}
          <div className="col-md-4 d-flex align-items-center">
            {/* Breadcrumb */}
            <nav className="d-none d-md-flex align-items-center">
              <a href="/project/view" className='dashboard-link'><span className="small me-2">DCode</span> </a>
              <span className="text-muted small me-2">/</span>
              <span className="fw-medium small" style={{ color: theme.text }}>
                {pageTitle}
              </span>
            </nav>
          </div>

          {/* Center Section - Search */}
          {/* <div className="col-md-4 d-flex justify-content-center">
            <div className="position-relative w-100" style={{ maxWidth: '400px' }}>
              <div
                className="position-relative"
                style={{
                  transform: searchFocused ? 'scale(1.02)' : 'scale(1)',
                  transition: 'transform 0.3s ease'
                }}
              >
                <Search
                  size={16}
                  className="position-absolute top-50 start-0 translate-middle-y ms-3"
                  style={{ color: theme.textSecondary }}
                />
                <input
                  type="text"
                  placeholder="Search projects, files, or commands..."
                  className="form-control border-0 rounded-3 ps-5 pe-5"
                  style={{
                    background: theme.glassBg,
                    backdropFilter: 'blur(10px)',
                    color: theme.text,
                    fontSize: '14px',
                    height: '42px',
                    boxShadow: searchFocused ? '0 0 0 3px rgba(102, 126, 234, 0.2)' : 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onFocus={() => setSearchFocused(true)}
                  onBlur={() => setSearchFocused(false)}
                />
                <Search
                  size={16}
                  className="position-absolute top-50 end-0 translate-middle-y me-3"
                  style={{ color: theme.textSecondary }}
                />
              </div>
            </div>
          </div> */}

          <div className="col-md-4 d-flex justify-content-center">

          </div>


          {/* Right Section */}
          <div className="col-md-4 d-flex align-items-center justify-content-end ">
            {/* Action Buttons */}
            <div className="d-flex align-items-center gap-2">
              {/* Fullscreen Button */}
              <button
                onClick={handleFullscreen}
                className="btn btn-sm p-2 rounded-3 border-0"
                style={{
                  background: theme.glassBg,
                  color: theme.text,
                  backdropFilter: 'blur(10px)',
                  transition: 'all 0.3s ease'
                }}
                title="Toggle Fullscreen"
              >
                {document.fullscreenElement ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
              </button>


              {/* User Profile */}
              <div className="position-relative">
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="btn btn-sm d-flex align-items-center p-2 rounded-3 border-0"
                  style={{
                    background: theme.glassBg,
                    color: theme.text,
                    backdropFilter: 'blur(10px)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div
                    className="rounded-circle me-2 d-flex align-items-center justify-content-center"
                    style={{
                      width: '32px',
                      height: '32px',
                      background: 'linear-gradient(135deg, #75C4C0 0%, #75C4C0 100%)',
                      color: 'white'
                    }}
                  >
                    <User size={14} />
                  </div>
                  <div className="d-none d-lg-block text-start me-2">
                    <div className="small fw-medium">{displayName}</div>

                  </div>
                  <ChevronDown
                    size={14}
                    style={{
                      transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease'
                    }}
                  />
                </button>

                {/* User Dropdown */}
                {isDropdownOpen && (
                  <div
                    className="position-absolute top-100 end-0 mt-2 rounded-3 shadow-lg border"
                    style={{
                      width: '220px',
                      background: theme.dropdownBg,
                      backdropFilter: 'blur(20px)',
                      border: `1px solid ${theme.border}`,
                      zIndex: 1000
                    }}
                  >
                    <div className="p-3 border-bottom" style={{ borderColor: theme.border }}>
                      <div className="d-flex align-items-center">

                        <div>
                          <div className="fw-medium" style={{ color: theme.text }}>{displayName}</div>
                          <div className="small text-muted">{getEmail}</div>
                        </div>
                      </div>
                    </div>

                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Click outside to close dropdowns */}
      {(isDropdownOpen || isNotificationOpen) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 999 }}
          onClick={() => {
            setIsDropdownOpen(false);
            setIsNotificationOpen(false);
          }}
        />
      )}

      {/* <style jsx>{`
        
      `}</style> */}
    </header>
  );
};

export default Header;